import { IEntity } from './interface-entity';

/**
 * å®ä½æ½è±¡ç±»
 */
export abstract class EntityBase implements IEntity {
    Id: string;
}